var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasModule.advertisements)?_c('AdCards',{attrs:{"position":_vm.settings.position,"data-cy":"AdvertismentsBlock"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }